import { Navigate, useParams } from 'react-router-dom'
import { FensterRahmen, EinsatzWahl } from '@pilot-hub/ui'
import { TaktischeKartePage } from '../pages/TaktischeKartePage'
import { LiveVideoPage } from '../pages/LiveVideoPage'
import { KraefteManagementPage } from '../pages/KraefteManagementPage'

/** /fenster/<ansicht>: eine gelöste Ansicht ohne Rail, Dock und Navigation (Multimonitor). Die Einsatzwahl bleibt in der Kopfzeile. */
const ANSICHTEN: Record<string, { titel: string; seite: () => JSX.Element }> = {
  karte: { titel: 'Taktische Karte', seite: TaktischeKartePage },
  livebild: { titel: 'Live-Video', seite: LiveVideoPage },
  kraefte: { titel: 'Kräfte Management', seite: KraefteManagementPage },
}

export function FensterSeite() {
  const { ansicht = '' } = useParams()
  const a = ANSICHTEN[ansicht]
  if (!a) return <Navigate to="/verwaltung" replace />
  const Seite = a.seite
  return <FensterRahmen titel={`Führung · ${a.titel}`} kopf={<EinsatzWahl />}><Seite /></FensterRahmen>
}
